export enum TipoFiltro{
    PASTILLA,
    DESPLEGABLE,
    FECHA,
    TEXTO //buscador
}
